module.exports = __webpack_public_path__ + "static/media/logo-noordhen.88a73079.svg";